import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Power } from "lucide-react";
import api, { formatErr } from "../../lib/api";
import { useSite } from "../../contexts/SiteContext";

export default function DevMaintenance() {
  const { refresh } = useSite();
  const [s, setS] = useState({});
  useEffect(()=>{ api.get("/developer/settings").then(r=>setS(r.data)); }, []);
  const toggle = async () => {
    try {
      await api.put("/developer/maintenance", { on: !s.maintenance_mode, message: s.maintenance_message });
      toast.success(s.maintenance_mode? "Site is live" : "Maintenance mode ON"); refresh();
      const r = await api.get("/developer/settings"); setS(r.data);
    } catch (e) { toast.error(formatErr(e)); }
  };
  const saveMsg = async () => {
    try { await api.put("/developer/settings", { maintenance_message: s.maintenance_message }); toast.success("Message saved"); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Operations</div><h1 className="font-display text-4xl text-white">Maintenance Mode</h1></div>
      <div className={`card-luxe p-8 ${s.maintenance_mode? "border-red-400/40" : ""}`}>
        <div className="flex items-center justify-between">
          <div>
            <div className="overline mb-2">Status</div>
            <div className={`font-display text-3xl ${s.maintenance_mode? "text-red-400":"text-[#32D74B]"}`}>{s.maintenance_mode? "● Maintenance ON":"● Live"}</div>
            <p className="text-white/50 text-sm mt-2 max-w-md">When ON, the entire storefront is replaced with a maintenance overlay. Only the Developer can still access dashboards.</p>
          </div>
          <button data-testid="maint-toggle" onClick={toggle} className={s.maintenance_mode? "btn-outline":"btn-primary"}><Power size={14}/> {s.maintenance_mode? "Turn Off" : "Turn On"}</button>
        </div>
      </div>
      <div className="card-luxe p-6">
        <div className="overline mb-3">Maintenance Message</div>
        <textarea rows={4} className="input-box resize-none" value={s.maintenance_message||""} onChange={(e)=>setS({...s, maintenance_message:e.target.value})}/>
        <button onClick={saveMsg} className="btn-primary mt-3">Save Message</button>
      </div>
    </div>
  );
}
